import { SelectCompanySection } from "@neonumy/neonumy-ui";
import { Layout } from "antd";
import useCompanySelection from "hooks/useCompanySelection";
import useUserDataStore from "hooks/useUserDataStore";
import { useNavigate } from "react-router-dom";

export default function CompanySelectionCard(): React.ReactElement {
  const navigate = useNavigate();
  const { saveCompany } = useCompanySelection();

  const companySelect = useUserDataStore(state => state.companySelect);
  const accountingFirmSelect = useUserDataStore(state => state.accountingFirmSelect);
  const setCompanySelect = useUserDataStore(state => state.setCompanySelect);
  const setAccountingFirmSelect = useUserDataStore(state => state.setAccountingFirmSelect);
  const setCompanyData = useUserDataStore(state => state.setCompanyData);

  return (
    <Layout className="landing-page-no-content">
      <SelectCompanySection
        companySelected={companySelect}
        accountingFirmSelected={accountingFirmSelect}
        selectCompanyOptions={{
          isEditable: true,
          handleOnSelectCompany: companyData => saveCompany(companyData as CompanySelect),
          handleOnSelectAccountingFirm: value => {
            const accountingFirm = value as AccountingFirm;
            setAccountingFirmSelect({ id: accountingFirm.id, name: accountingFirm.name });
            setCompanySelect(undefined);
            setCompanyData(undefined);
            navigate("/");
          },
        }}
      />
    </Layout>
  );
}
